export default __webpack_public_path__ + "static/media/raphael.1c7667f8.png";